import { IssueTracker } from '../../../cimsPage/instances/issues'
import { BasicPermissionItem } from '../../PermissionItem'
import {
  CreateViewEditSoftRemoveRestore,
  GiveDisposition,
  Revert,
  Simple,
  Unlock,
} from '../../common'

const page = IssueTracker
const object = 'Issue'

const { Create, Edit, RemoveRestore, View } = CreateViewEditSoftRemoveRestore({
  page,
  object,
  create: 'd7688c82-8de5-4c63-9339-4b74dbd84396',
  edit: '897f20e9-21f5-4c8c-b0c9-f723d9050b22',
  removeRestore: 'b95e16e3-f6e2-409a-a74a-623abe6cf32e',
  view: '1d82df89-0454-46aa-93ac-71d66f8661b0',
})

export const CreateIssue = Create
export const EditIssue = Edit
export const RemoveRestoreIssue = RemoveRestore
export const ViewIssue = View

export const EditIssueResponse = new BasicPermissionItem({
  id: 'ce547fa9-b01d-43ab-b951-5601650fcc7b',
  page,
  action: 'Edit Response',
  name: 'Edit Issue Response',
})

export const CommentOnIssue = Simple({
  id: '93474e4d-6aeb-4ae0-b9d0-c14fc41ebeb7',
  action: 'Comment on',
  object,
  page,
})

export const RevertIssue = Revert({
  id: '6ffe8123-9acc-48c1-b918-dd6243737d7f',
  object,
  page,
})

export const UnlockIssue = Unlock({
  id: 'e8fe7aab-3962-40f2-bd36-af6cf5d8c93e',
  page,
  object,
})

export const RespondToIssue = new BasicPermissionItem({
  id: '24f1b3a8-27be-41a4-842b-6683bbc6bc93',
  name: 'Respond',
  action: `respond to an ${object}`,
  allowMixedCase: true,
  page,
})

export const GiveIssueDisposition = GiveDisposition({
  id: 'a5ec93bd-6a73-4abd-aae6-1c74deefd10f',
  object,
  page,
})

export const CloseIssue = Simple({
  id: '27e11ca1-817f-440f-95d0-7526539d2c63',
  action: 'Close',
  object,
  page,
})

export type IssueTrackerPermission =
  | typeof CreateIssue
  | typeof EditIssue
  | typeof RemoveRestoreIssue
  | typeof ViewIssue
  | typeof EditIssueResponse
  | typeof CommentOnIssue
  | typeof RevertIssue
  | typeof UnlockIssue
  | typeof RespondToIssue
  | typeof GiveIssueDisposition
  | typeof CloseIssue
